import { observable, reaction } from 'mobx';
// import { autobind } from 'core-decorators';
import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';

class MapStore extends BaseStore {
  @observable tabIndex = -1;
  @observable playNextDuration = 16000; // 自动播放下一张的时间间隔
  timer = null;

  // 地图数据
  @observable slidesData;

  swiperStore = new BaseSwiperStore({
    swiperOptions: {
      spaceBetween: 0,
      effect: 'fade',
      observe: true,
      observeParents: true,
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false
    }
  });

  changeTab = index => {
    this.tabIndex = index;
    this.playNextDuration = 16000 / (index + 1);
    this.playSwiper();
  };

  playSwiper = () => {
    this.tabIndex = -1;
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.playNextDuration -= 30;
      this.tabIndex = +!parseInt(this.playNextDuration / 8000, 10);
      // this.tabIndex = 0;
      if (this.playNextDuration <= 0) {
        this.playNextDuration = 16000;
      }
    }, 30);
  };

  playPrev = () => {
    this.changeSwiper(this.swiperStore.activeIndex - 1 < 0 ? this.slidesData.length - 1 : this.swiperStore.activeIndex - 1);
  };

  playNext = () => {
    this.changeSwiper(this.swiperStore.activeIndex + 1 > this.slidesData.length - 1 ? 0 : this.swiperStore.activeIndex + 1);
  };

  changeSwiper = index => {
    clearInterval(this.timer);
    this.playNextDuration = 16000;
    this.tabIndex = -1;
    this.swiperStore.onChange(index);
  };

  use() {
    super.use();

    useMount(async () => {
      this.playSwiper();

      reaction(
        () => this.swiperStore.activeIndex,
        () => {
          this.playSwiper();
        }
      );
      return () => {
        clearInterval(this.timer);
      };
    });
    const data = useFunLinkPageData();

    useEffect(
      () => {
        if (!data) {
          return;
        }
        let result = data?.map_list?.map(itemA => {
          // 找出对应key值的所有b数组项
          let matchingB = data?.contentList?.filter(itemB => itemB?.mapContentCode === itemA?.mapCode);
          //console.log(matchingB);
          // 将a项和对应的b项合并
          return { ...itemA, contentList: matchingB };
        });
        //console.log(result);
        this.slidesData = result;
      },
      [data]
    );
  }
}

export default MapStore;
